<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-multi-select-edit-control formControlName="validBillingCycles"
                                                   [(ngModel)]="model.data.validBillingCycles"
                                                   (onSelect)="changeValidBillingCycles()">
                        <wbo-select-options>
                            <wbo-select-option [value]="AccountTypeData.BILLING_CYCLE_NONE"
                                               label="wbo.account-type.edit.option.validBillingCycles.none">
                            </wbo-select-option>
                            <wbo-select-option [value]="AccountTypeData.BILLING_CYCLE_WEEKLY"
                                               label="wbo.account-type.edit.option.validBillingCycles.weekly">
                            </wbo-select-option>
                            <wbo-select-option [value]="AccountTypeData.BILLING_CYCLE_MONTHLY"
                                               label="wbo.account-type.edit.option.validBillingCycles.monthly">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-multi-select-edit-control>
                    <wbo-billing-cycle-single-select-edit-control formControlName="defaultBillingCycleDbValue"
                                                                  [(ngModel)]="model.data.defaultBillingCycleDbValue"
                                                                  [validBillingCycles]="this.model.data.validBillingCycles"></wbo-billing-cycle-single-select-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <fui-tandem-field>
                    <wbo-numeric-edit-control formControlName="defaultTerms"
                                              [(ngModel)]="model.data.defaultTerms"></wbo-numeric-edit-control>
                    <wbo-checkbox-edit-control formControlName="deferWeekendDueDate"
                                               [(ngModel)]="model.data.deferWeekendDueDate">
                    </wbo-checkbox-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
